export default __webpack_public_path__ + "f8f612e076f276088b216941570d9c45.jpg";